import { StyleSheet } from '@react-pdf/renderer';

export const buildingLayoutDataStyles = StyleSheet.create({
  row: {
    display: 'flex',
    flexDirection: 'row',
    gap: 10,
    width: '100%',
  },
  rowItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    width: '50%',
    border: '1px solid #CCCCCC',
    padding: 12,
  },
  fullWidthItem: {
    width: '100%',
    padding: 12,
    border: '1px solid #CCCCCC',
    marginTop: 12,
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
  },
  phasingEstimate: {
    padding: '0px 8px',
    fontFamily: 'Open Sans Normal',
    fontSize: 11,
    color: '#373D3F',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: 27,
  },
  good: {
    backgroundColor: '#CFFFD4',
  },
  bad: {
    backgroundColor: '#FF1F1F',
    color: '#FFF',
  },
});

export const headerStyles = StyleSheet.create({
  header: {
    backgroundColor: '#F3F5F9',
    padding: 24,
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    width: '100%',
    marginBottom: 16,
  },
  title: {
    fontFamily: 'Open Sans Bold',
    fontSize: 10,
    color: '#793EAD',
    textTransform: 'uppercase',
  },
  sectionTitle: {
    color: '#000000',
    fontFamily: 'Open Sans Bold',
    fontSize: 24,
  },
  characteristicsContainer: {
    display: 'flex',
    flexDirection: 'row',
    color: '#383939',
    fontSize: 16,
    fontFamily: 'Open Sans Semi Bold',
  },
});

export const tableStyles = StyleSheet.create({
  sectionTitle: {
    fontFamily: 'Open Sans Semi Bold',
    color: '#1E1E1E',
    fontSize: 12,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    height: 27,
    alignItems: 'center',
    fontFamily: 'Open Sans Normal',
    fontSize: 11,
    padding: '0px 8px',
    color: '#373D3F',
  },
  oddRow: {
    backgroundColor: '#C4C4C42B',
    opacity: 0.17,
  },
  evenRow: {
    backgroundColor: '#FFF',
  },
});
